import { render, staticRenderFns } from "./EquipmentIndustrial.vue?vue&type=template&id=1bbdc037&scoped=true"
import script from "./EquipmentIndustrial.vue?vue&type=script&lang=js"
export * from "./EquipmentIndustrial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdc037",
  null
  
)

export default component.exports